export const APP_VERSION = '2.6.4';
export const APP_BUILD_DATE = '26 Octombrie 2026';
export const APP_BUILD_TAG = 'Eliminare Microfonie Partajare Ecran (WebRTC AEC3, Strip Audio Spotlight, Protecție Buclă Difuzor Multi-Client)';

